export class Order {
  constructor({
    locationId = "",
    orderType = null,
    contractTermLength = "",
    avcdBandwidthProfile = "",
    rspDeliveryCircuit = "",
    customerFirstName = "",
    customerLastName = "",
    customerContactNumber = "",
    customerContactEmail = "",
    customerAuthDate = "",
    customerAuthReference = "",
    unidslPotsInterconnect = "",
    serviceClass = "",
    customerReference = "",
    centralSplitter = "",
    specialInstruction = "",
    portingNumber = "",
    cpiId = "",
    ntdId = "",
    installationWorkforce = "",
    contactFirstName = "2SG",
    contactLastName = "Support",
    contactNumber = "1800828668",
    contactEmail = "",
    deliveryInstructions = "",
    csaId = "",
    unidPortId = "",
    serviceId = "",
    wholesalerAccountNumber = "",
    ratePlanID = 0,
    deliveryAddress = "",
    deliveryContactName = "",
    deliveryContactCompany = "",
    ubCustomerNumber = 0,
    isRetail = true,
    deliverToCustomer = true,
    ratePlanDescription = "",
    radiusUsername = "",
    radiusPassword = "",
    staticIP = false
  } = {}) {
    (this.locationId = locationId),
      (this.orderType = orderType),
      (this.contractTermLength = contractTermLength),
      (this.avcdBandwidthProfile = avcdBandwidthProfile),
      (this.rspDeliveryCircuit = rspDeliveryCircuit),
      (this.customerFirstName = customerFirstName),
      (this.customerLastName = customerLastName),
      (this.customerContactNumber = customerContactNumber),
      (this.customerContactEmail = customerContactEmail),
      (this.customerAuthDate = customerAuthDate),
      (this.customerAuthReference = customerAuthReference),
      (this.unidslPotsInterconnect = unidslPotsInterconnect),
      (this.serviceClass = serviceClass),
      (this.customerReference = customerReference),
      (this.centralSplitter = centralSplitter),
      (this.specialInstruction = specialInstruction),
      (this.portingNumber = portingNumber),
      (this.cpiId = cpiId),
      (this.ntdId = ntdId),
      (this.installationWorkforce = installationWorkforce),
      (this.contactFirstName = contactFirstName),
      (this.contactLastName = contactLastName),
      (this.contactNumber = contactNumber),
      (this.contactEmail = contactEmail),
      (this.deliveryInstructions = deliveryInstructions),
      (this.csaId = csaId),
      (this.unidPortId = unidPortId),
      (this.serviceId = serviceId),
      (this.wholesalerAccountNumber = wholesalerAccountNumber),
      (this.ratePlanID = ratePlanID),
      (this.deliveryAddress = deliveryAddress),
      (this.deliveryContactName = deliveryContactName),
      (this.deliveryContactCompany = deliveryContactCompany),
      (this.ubCustomerNumber = ubCustomerNumber),
      (this.isRetail = isRetail),
      (this.deliverToCustomer = deliverToCustomer),
      (this.ratePlanDescription = ratePlanDescription);
    this.radiusUsername = radiusUsername;
    this.radiusPassword = radiusPassword;
    this.staticIP = staticIP;
  }
}

export function createOrder(data) {
  return Object.freeze(new Order(data));
}
